module.exports = __webpack_public_path__ + "static/media/f6.c32a1585.jpg";